import { AppointmentService } from '@agent/core/contact/appointment.service';
import { downgradeComponent } from '@angular/upgrade/static';
import { module } from 'angular';

import { State } from './';
import { default as visioQualificationActionsName, VisioQualificationActions } from './qualification/visio-qualification-actions.component';
import { VisioQualificationWorkspaceComponent } from './qualification/visio-qualification-workspace.component';
import { VisioActionsComponent } from './visio-actions.component';
import { default as visioInfoName, VisioInfo } from './visio-info.component';
import { VisioWorkspaceComponent } from './visio-workspace.component';

export default module('contact.agent.contact-view.visio', [State])
  // DOWNGRADED COMPONENT
  .directive('cngVisioActions', downgradeComponent({ component: VisioActionsComponent }) as angular.IDirectiveFactory)
  .directive('cngVisioWorkspace', downgradeComponent({ component: VisioWorkspaceComponent }) as angular.IDirectiveFactory)
  .directive(
    'cngVisioQualificationWorkspace',
    downgradeComponent({ component: VisioQualificationWorkspaceComponent }) as angular.IDirectiveFactory
  )
  .component(visioInfoName, new VisioInfo())
  .component(visioQualificationActionsName, new VisioQualificationActions())
  .service(AppointmentService).name;
